/**
 * Componentes básicos «Despacho» (GEN-PX-001). Finos: solo ponen las clases
 * `dk-*` de styles/componentes-despacho.css, que consumen los tokens. Las
 * pantallas nuevas importan de aquí en vez de escribir estilos propios.
 */
import '../styles/tokens-despacho.css'
import '../styles/componentes-despacho.css'

const cx = (...c) => c.filter(Boolean).join(' ')

export function Boton({ variante = 'secundario', className, ...props }) {
  return <button type="button" className={cx('dk-btn', variante === 'primario' && 'dk-btn--primario', className)} {...props} />
}

export function Tarjeta({ titulo, children, className }) {
  return (
    <div className={cx('dk-tarjeta', className)}>
      {titulo && <h3 className="dk-tarjeta__titulo">{titulo}</h3>}
      {children}
    </div>
  )
}

export function Insignia({ children }) {
  return <span className="dk-insignia">{children}</span>
}

/** tipo: 'verde' | 'ambar' | 'azul' */
export function EtiquetaTipo({ tipo = 'verde', children }) {
  return <span className={cx('dk-etiqueta', tipo !== 'verde' && `dk-etiqueta--${tipo}`)}>{children}</span>
}

/** Foto si hay `foto` (agente); si no, iniciales (persona). `agente`: sin foto, iniciales con el estilo de agente. */
export function Avatar({ foto, iniciales, nombre, tamano = 32, activo = false, agente = false }) {
  return (
    <span
      className={cx('dk-avatar', !foto && iniciales && !agente && 'dk-avatar--persona', activo && 'dk-avatar--activo')}
      style={{ '--dk-av': `var(--dk-av-${tamano})` }}
      role="img"
      aria-label={nombre}
    >
      {foto ? <img src={foto} alt="" /> : iniciales}
    </span>
  )
}

/** lado: 'arriba' (por defecto) | 'derecha' (raíl). clase: modificador extra (p. ej. `dk-tooltip--texto`, para texto largo). */
export function Tooltip({ texto, detalle, abierto = false, lado = 'arriba', clase, children }) {
  return (
    <span className={cx('dk-tooltip', lado === 'derecha' && 'dk-tooltip--derecha', abierto && 'dk-tooltip--abierto', clase)}>
      {children}
      <span className="dk-tooltip__caja" role="tooltip">
        {texto}
        {detalle && <small>{detalle}</small>}
      </span>
    </span>
  )
}

/** Pestañas «Despacho» (GEN-PX-014). pestanas: [{id, texto}]. */
export function Pestanas({ pestanas, activa, onCambio, etiqueta }) {
  return (
    <div className="dk-pestanas" role="tablist" aria-label={etiqueta}>
      {pestanas.map(p => (
        <button
          key={p.id}
          type="button"
          role="tab"
          aria-selected={p.id === activa}
          className={cx('dk-pestana', p.id === activa && 'dk-pestana--activa')}
          onClick={() => onCambio(p.id)}
        >
          {p.texto}
        </button>
      ))}
    </div>
  )
}
